import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchCatalogues = createAsyncThunk(
  "catalogues/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get("/catalogues", { params });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const createCatalogue = createAsyncThunk(
  "catalogues/create",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/catalogues", formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur création");
    }
  }
);

export const updateCatalogue = createAsyncThunk(
  "catalogues/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/catalogues/${id}`, formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur modification");
    }
  }
);

export const deleteCatalogue = createAsyncThunk(
  "catalogues/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/catalogues/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression");
    }
  }
);

const catalogueSlice = createSlice({
  name: "catalogues",
  initialState: { list: [], loading: false, error: null, success: null, total: 0, page: 1, pages: 1 },
  reducers: {
    clearCatalogueMessages: (state) => { state.error = null; state.success = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalogues.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCatalogues.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
        state.total = action.payload.total ?? state.list.length;
        state.page = action.payload.page ?? 1;
        state.pages = action.payload.pages ?? 1;
      })
      .addCase(fetchCatalogues.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createCatalogue.fulfilled, (state, action) => { state.list.push(action.payload); state.success = "Catalogue créé."; })
      .addCase(createCatalogue.rejected,  (state, action) => { state.error = action.payload; })
      .addCase(updateCatalogue.fulfilled, (state, action) => {
        const idx = state.list.findIndex((c) => c._id === action.payload._id);
        if (idx !== -1) state.list[idx] = action.payload;
        state.success = "Catalogue mis à jour.";
      })
      .addCase(updateCatalogue.rejected,  (state, action) => { state.error = action.payload; })
      .addCase(deleteCatalogue.fulfilled, (state, action) => { state.list = state.list.filter((c) => c._id !== action.payload); state.success = "Catalogue supprimé."; })
      .addCase(deleteCatalogue.rejected,  (state, action) => { state.error = action.payload; });
  },
});

export const { clearCatalogueMessages } = catalogueSlice.actions;
export default catalogueSlice.reducer;
